import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Button, SubmitButton } from '@app/core';
import { Stepper } from '../Stepper';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  stepsLinePlaceholder: {
    marginTop: theme.marginBase * 3,
    width: '100%',
    height: theme.height.small + theme.marginBase * 9,
  },
  stepsLine: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    height: theme.height.small + theme.marginBase * 6,
    padding: theme.marginBase * 3,
    textAlign: 'right',
    backgroundColor: theme.colors.white,
    boxShadow: theme.boxShadow.base,
  },
  steps: {
    position: 'absolute',
    right: 0,
    left: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface Props {
  stepsCount: number;
  currentStep: number;
  setActiveStep: (step: number) => void;
  allowSkip?: boolean;
  onSkip?: () => void;
}

export const BillingModalButtons = ({
  stepsCount,
  currentStep,
  setActiveStep,
  allowSkip,
  onSkip,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const isLastStep = stepsCount === currentStep + 1;

  return (
    <>
      <div className={classes.stepsLinePlaceholder} />
      <div className={classes.stepsLine}>
        <div className={classes.steps}>
          <Stepper
            activeStep={currentStep}
            requestStepChange={setActiveStep}
            stepsCount={stepsCount}
          />
        </div>

        {allowSkip && (
          <Button
            type="button"
            small
            color="blue"
            variant="transparent"
            text={t('billing.paymentMethod.buttons.skip')}
            onClick={onSkip}
          />
        )}

        <SubmitButton
          small
          withNextArrow={!isLastStep}
          color={isLastStep ? 'green' : 'blue'}
          text={
            isLastStep
              ? t('billing.paymentMethod.buttons.save')
              : t('billing.paymentMethod.buttons.next')
          }
        />
      </div>
    </>
  );
};
